import React, { useEffect, useRef, useState } from 'react';

/** Renders children only when the block is about to scroll into view, so the first load stays small. */
const LazySection = ({ children, minHeight = 320, rootMargin = '300px', className = '' }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(typeof IntersectionObserver === 'undefined');
  useEffect(() => {
    if (show || !ref.current) return undefined;
    const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { setShow(true); io.disconnect(); } }, { rootMargin });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [show, rootMargin]);
  return <div ref={ref} className={className} style={show ? undefined : { minHeight }}>{show ? children : null}</div>;
};
export default LazySection;
